/********************************************************************
 * Project: WDCK（2021）
 * Class: InputTimeDirective
 * ----------------------------------------
 * <summary>
 * Input Time Directive
 * </summary>
 * <history>
 *      ThaiTV     2021/06/08      Create
 * </history>
 ********************************************************************/
import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[inputTime]',
})
export class InputTimeDirective {
    @Output() ngModelChange = new EventEmitter();
    constructor(private el: ElementRef) {
    }

    @HostListener('paste', ['$event']) blockPaste(event) {
        const clipboardData = event.clipboardData;
        if (clipboardData) {
            const pastedText = clipboardData.getData('text/plain');
            const valid: boolean = (new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$')).test(pastedText);
            if (!valid && pastedText.match(/[^0-9]/)) {
                event.preventDefault();
            }
            if (pastedText.length >= 5) {
                this.el.nativeElement.value = pastedText.replace(':', '').slice(0, 4);
            }
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event) {
        if (event.shiftKey) {
            event.preventDefault();
        }
        if (event.ctrlKey || event.metaKey ||
            event.which === 8 || event.which === 9 || event.which === 37 ||
            event.which === 39 || event.which === 46 || (event.which >= 112 && event.which <= 123)) {
            return;
        } else if (event.which < 48 || (event.which > 57 && event.which < 96) || event.which > 105) {
            return false;
        }
    }

    @HostListener('focus', ['$event'])
    onFocus() {
        this.el.nativeElement.value = this.el.nativeElement.value.replace(':', '');
    }

    @HostListener('blur', ['$event'])
    onFocusOut() {
        const current: string = this.el.nativeElement.value.replace(/[^0-9]/g, '');
        this.el.nativeElement.value = this.formatTime(current);
        this.ngModelChange.emit(this.el.nativeElement.value);
    }

    formatTime(time) {
        if (!time) {
            return '';
        }
        let value = time.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return time;
        }
        if (value.length >= 5 && value.indexOf(':') === -1) {
            value = value.slice(0, 4);
        }
        let hours: any;
        let minutes: any;
        switch (value.length) {
            case 1:
            case 2:
                hours = value;
                break;
            case 3:
                hours = value.slice(0, 2);
                minutes = value.slice(2);
                break;
            case 4:
                hours = value.slice(0, 2);
                minutes = value.slice(2, 4);
                break;
            default:
                hours = value;
        }
        if (minutes) {
            return (hours + ':' + minutes).trim();
        } else {
            return hours;
        }
    }

}
